<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="name">Name</label>
                    <input type="text" id="name" class="form-control" [(ngModel)]="target.name" name="name" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <div class="form-group">
                    <label for="status">Status</label>
                    <wj-combo-box
                        #statusComboBox
                        id="status"
                        [(ngModel)]="target.status"
                        name="status"
                        (selectedIndexChanged)="updateDoneDate()"
                        [itemsSource]="statusMap"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="false"
                        (itemsSourceChanged)="statusBound()"
                    ></wj-combo-box>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <label for="assignedUserId">Ownership</label>
                    <wj-combo-box
                        id="assignedUserId"
                        [(ngModel)]="target.assignedUserId"
                        name="assignedUserId"
                        [itemsSource]="userMap"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="false"
                    ></wj-combo-box>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <div class="form-group">
                    <label for="dueDate">Due Date</label>
                    <wj-input-date id="dueDate" [(ngModel)]="target.dueDate" name="dueDate" [isRequired]="false"></wj-input-date>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <label for="doneDate">Done Date</label>
                    <wj-input-date id="doneDate" [(ngModel)]="target.doneDate" name="doneDate" [isRequired]="false"></wj-input-date>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="notes">Notes</label>
                    <app-voice-text-field
                        [(ngModel)]="target.notes"
                        name="notes"
                        inputId="notes"
                        [rows]="3"
                    ></app-voice-text-field>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
